// appID
const appID = `wx02b2ba1d396150ac`
// appsecret
const appSerect = `3a738e98c938568123241039f51f17c6`

const host = `http://127.0.0.1:8099`

// const apiPath = 'http://xgame.cm724.com/api/xgame/'

const apiPath = 'http://oltestxgame.cm724.com/api/xgame/'

export { appID, appSerect, host, apiPath }



// WEBPACK FOOTER //
// ./src/assets/js/baseConfig.js